import {Entity} from '../entity/entity';

export class ExtendedWarrantyUtils {

  static canWarrantyBeChanged(entity: Entity): boolean {
    if (entity && entity.lines && entity.lines.length > 0) {
      const configuredLines = entity.lines.filter(line => line.configured);
      const hasOneUnit = configuredLines.length > 0;
      const allPrnsValid = configuredLines.filter(line => line.prn?.indexOf('INVALID') >= 0).length === 0;
      return entity && entity.approvalStatus !== 'Approved' && entity.approvalStatus !== 'Approved - Need Releases'
        && !entity.frozen && !entity.id.entityId.startsWith('R') && hasOneUnit && allPrnsValid;
    }
    return false;
  }

}
